// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Components
import { LyonEmptyStateInfo } from '@lyon/components/empty/LyonEmptyState/LyonEmptyStateInfo';
import { constant } from '@lyon/components/utils/constant';

// ANCHOR Constants
import { LABEL } from './constants';

// ANCHOR Styles
import { BLOCK, IMAGE_BLOCK } from './styles';

export const LyonUpdateFormContentInitial = constant(() => (
  <Block overrides={BLOCK}>
    <Block overrides={IMAGE_BLOCK}>
      <Block
        display="grid"
        justifyContent="center"
        alignItems="center"
        marginBottom="32px"
      >
        <LyonEmptyStateInfo label={LABEL} type="default" />
      </Block>
    </Block>
  </Block>
));
